import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import bloodDonationQuery, {
  deleteBloodDonation,
} from "../../utils/queries/bloodDonationQuery";
import { ConfirmationModal, DeleteModal, Modal } from "../Modal";
import {
  defineRole,
  defineRoleCenterSite,
} from "../../utils/handleAccessRoles";
import { getStorage } from "../../utils/storage";
import icons from "../../constants/icons";
import toastMessage from "../../utils/toastMessage";
import axios from "axios";
import ViewVitalSign from "../VitalSigns/ViewSingleSign";
import { ROLE_COLLECTIONS } from "../../constants/ROLES";
import handleFilters from "../../utils/handleFilters";
import moment from "moment";

// eslint-disable-next-line no-unused-vars
let copyData = [];

// eslint-disable-next-line no-unused-vars
class BlockedBloodCollection extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    suspendReason: "",
    filters: {
      startDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      endDate: moment().endOf("d").format("YYYY-MM-DD"),
    },
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.fetchData(true, this.state.filters);
  };

  fetchData = async (isLoading, search) => {
    this.setState({ filters: search });

    this.getData(isLoading, search);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e && e?.target ? e?.target?.value : e,
      error,
    });
  }

  getData = async (isLoading = false, search = {}) => {
    try {
      const { page, limit } = this.state;
      const {
        defaultLanguage,
        filters,
        centerId,
        centerSiteId,
        customFilters,
      } = this.props;

      this.setState({ isLoading });

      const { centerRole, centerSiteRole } = await defineRoleCenterSite();

      const { data, count, totalRecords } = await bloodDonationQuery(defaultLanguage, {
        page,
        limit,
        donor: this.props.donorId,
        id: this.props.donationId,
        center: centerId || centerRole,
        centerSite: centerSiteId || centerSiteRole,
        ...handleFilters(filters),
        ...search,
        ...(customFilters || {}),
        "blockInfo.blocked": true,
      });
      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true, this.state.filters);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
      reason: selectedData.reason || "",
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].donation_number,
        key: "donationNumber",
        type: "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/donations/${item._id}/${
            item.donor._id
          }/${item.donor.firstName + " " + item.donor.lastName}`),
        copyEnabled: true,
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].donor,
        key: "donor.donorNumber",
        type: "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/donations/${item._id}/${
            item.donor._id
          }/${item.donor.firstName + " " + item.donor.lastName}`),
        styles: {
          textTransform: "uppercase",
        },
        copyEnabled: true,
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "bloodInfo.bloodGroup",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].volume,
        key: "bloodInfo.volume",
      },
      {
        title: language[this.props.defaultLanguage].vital_sign,
        key: "collectionDate",
        type: "link",
        isMoment: true,
        formatTime: "lll",
        onPress: (item) =>
          this.handleShowModal(
            "showVitalSignModal",
            item._id || item,
            item?.vitalSign
          ),
        copyEnabled: true,
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].equipment_code,
        key: "equipment.code",
      },
      {
        title: language[this.props.defaultLanguage].equipment_name,
        key: "equipment.name",
      },
      {
        title: language[this.props.defaultLanguage].collection_date,
        key: "collectionDate",
        isMoment: true,
        formatTime: "ll",
      },
      {
        title: language[this.props.defaultLanguage].start_time,
        key: "startTime",
      },
      {
        title: language[this.props.defaultLanguage].end_time,
        key: "endTime",
      },
      {
        title: language[this.props.defaultLanguage].reaction,
        key: "reaction.isReaction",
      },
      {
        title: language[this.props.defaultLanguage].reaction_category,
        key: "reaction.category",
      },
      {
        title: language[this.props.defaultLanguage].reaction_comment,
        key: "reaction.comment",
      },
      {
        title: language[this.props.defaultLanguage].tested,
        key: "bloodInfo.tested",
      },
      // {
      //   title: language[this.props.defaultLanguage].is_active,
      //   key: "isActive",
      // },
      {
        title: language[this.props.defaultLanguage].center,
        key: "center.name",
      },
      {
        title: language[this.props.defaultLanguage].center_site,
        key: "centerSite.name",
      },
      {
        title: language[this.props.defaultLanguage].phlebotomist,
        key: "phlebotomist.email",
      },
      {
        title: language[this.props.defaultLanguage].collection_type,
        key: "collectionType.collectionTypeNumber",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].collection_type,
        key: "collectionType.name",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].reason,
        key: "blockInfo.blockReason",
      },
      {
        title: language[this.props.defaultLanguage].blood_donation_recorder,
        key: "addedBy.firstName",
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  onUpdateStatus = async (status, modal) => {
    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isUpdating: true,
      });

      let url = `${process.env.REACT_APP_BBMS_BASE_API}/blooddonation`,
        method = "PUT",
        user = await getStorage(),
        { selectedData, reason } = this.state;

      const options = {
        method,
        url,
        data: {
          status,
          id: selectedData._id,
          donor: selectedData?.donor?._id,
          vitalSign: selectedData?.vitalSign?._id,
          donationNumber: selectedData?.donation?._id,
          center: selectedData?.center?._id,
          centerSite: selectedData?.centerSite?._id,
          blockInfo: {
            blocked: false,
            blockReason: "",
            unblockReason: reason,
          },
          action: "unblock",
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      };

      console.log("I am here");

      axios(options)
        .then((data) => {
          this.setState({
            isUpdating: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage].data_update_success
          );

          this.handleCloseModal(modal);
          this.getData(true, this.state.filters);
        })
        .catch((error) => {
          this.setState({ isUpdating: false });
          toastMessage("error", error);
        });
    }
  };

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteBloodDonation(
        this.props.defaultLanguage,
        this.state.selectedData._id
      );

      this.setState({ isDeleting: false });

      this.getData(true, this.state.filters);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      q: search || search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  render() {
// eslint-disable-next-line no-unused-vars
    const { export_, add_collection } = language[this.props.defaultLanguage];

// eslint-disable-next-line no-unused-vars
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={this.handleSearch.bind(this)}
          addSearchButton
          searching={this.state.searching}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          showAdd={defineRole({
            roles: this.state.user.accessRole,
            menu: ROLE_COLLECTIONS,
            operation: "create",
            pass:
              this.state.user.role === "donor" ||
              this.state.user.account_type === "donor",
          })}
          fetchData={() => this.fetchData(true, this.state.filters)}
          addButtonText={add_collection}
          handleAddPressed={() =>
            this.handleShowModal(
              this.props.donorId ? "showModal" : "searchDonorModal",
              add_collection
            )
          }
          filters={[
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: (item) => this.fetchData(true, this.state.filters),
            },
            {
              type: "dropdown",
              filterName: "date_range",
              title: language[this.props.defaultLanguage].date_range,
              button_type: "dropdown",
              handleApplyFilters: () =>
                this.fetchData(true, this.state.filters),
            },
          ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_COLLECTIONS,
                operation: "update",
              }),
              name: language[this.props.defaultLanguage].unblock,
              onPress: this.handleShowModal.bind(
                this,
                "showBlockModal",
                language[this.props.defaultLanguage].unblock
              ),
              icon: icons.block,
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_COLLECTIONS,
                operation: "delete",
              }),
              name: language[this.props.defaultLanguage].delete,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                language[this.props.defaultLanguage].block_permanent
              ),
              icon: icons.delete,
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showVitalSignModal")}
          show={this.state.showVitalSignModal}
          title={this.state.modalTitle}
        >
          <ViewVitalSign
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showVitalSignModal"
            )}
            signId={this.state.selectedData?._id || this.state.selectedData}
            examQuestionnaire={
              this.state?.selectedData?.examQuestionnaire || []
            }
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showBlockModal")}
          show={this.state.showBlockModal}
          title={language[this.props.defaultLanguage].block}
        >
          <ConfirmationModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showBlockModal"
            )}
            error={this.state.error}
            onPressNegative={this.handleCloseModal.bind(
              this,
              "showSuspendModal"
            )}
            onPressPositive={() =>
              this.onUpdateStatus("pending", "showBlockModal")
            }
            onChange={(e) => this.onChangeText("reason", e)}
            isSubmitting={this.state.isSubmitting}
            getData={() => this.fetchData(true, this.state.filters)}
            withReason
            reason={this.state?.blockInfo?.blockReason || this.state.reason}
            {...this.props}
            reasonFieldName="reason"
            negativeButtonText={language[this.props.defaultLanguage].cancel}
            positiveButtonText={language[this.props.defaultLanguage].submit}
            isPositiveSubmitting={this.state.isUpdating}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.name}
            getData={() => this.fetchData(true, this.state.filters)}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(BlockedBloodCollection);
